import Main from "../components/layout/Main";
import React, { useState } from "react";
import { useSwipeable } from "react-swipeable";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

function Test() {
    const [tabIndex, setTabIndex] = useState(0);

    const handlers = useSwipeable({
      onSwipedLeft: () => setTabIndex((prev) => Math.min(prev + 1, 2)),
      onSwipedRight: () => setTabIndex((prev) => Math.max(prev - 1, 0)),
      preventDefaultTouchmoveEvent: true,
      trackMouse: true,
    });
  
    return (
      <Main>
        <section className="home-wrap px-lg-4 px-3 pb-lg-4 pb-3 container-fluid">
          <div className="row g-3">
            <div className="col-lg-12">
              <div className="pageHeader">Swipeable Tabs</div>
            </div>
            <div {...handlers} className="col-lg-12">
              <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                <TabList>
                  <Tab>Tab 1</Tab>
                  <Tab>Tab 2</Tab>
                  <Tab>Tab 3</Tab>
                </TabList>
  
                <TabPanel>
                  <p>Content for Tab 1</p>
                </TabPanel>
                <TabPanel>
                  <p>Content for Tab 2</p>
                </TabPanel>
                <TabPanel>
                  <p>Content for Tab 3</p>
                </TabPanel>
              </Tabs>
            </div>
          </div>
        </section>
      </Main>
    );
  }
export default Test;
